export default __webpack_public_path__ + "static/media/Become-a-seed.80152856.jpg";